export enum EDITOR_MODE {
  NEW = 'new',
  EDIT = 'edit',
}
